export default __webpack_public_path__ + "images/fetal_weight_blue.d073b4d49797327d4e30a75666db7576.png";